import {Component} from '@angular/core';
import {LANGUAGES} from './constants/language.constants';
import {TranslationsService} from '../translations.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'app-language',
    templateUrl: './language.component.html',
    styleUrls: ['./language.component.scss'],
    standalone: false
})
export class LanguageComponent {

  languages = LANGUAGES;

  languageForm: FormGroup;

  constructor(private translationService: TranslationsService, private formBuilder: FormBuilder) {
    this.languageForm = this.formBuilder.group({
      language: [this.translationService.currentLang, Validators.required]
    });
  }

  onSubmit() {
    let language = this.languageForm.get('language')?.value
    if (language) {
      this.translationService.changeLanguage(language);
    }
  }
}
